import { PerfChannel, IPerfSuggestion } from './models/perf-suggestion.model';
import { isSlow } from './perf-thresholds.const';

/**
 * Only called when profiling is enabled (see `provideProfiling`), so there is
 * no environment check here.
 */
export function logPerf(
  channel: PerfChannel.HTTP | PerfChannel.NAV,
  label: string,
  durationMs: number,
  suggestions: IPerfSuggestion[] = []
): void {
  const message = `[PERF:${channel}] ${label} ${Math.round(durationMs)}ms`;

  if (!isSlow(channel, durationMs)) {
    console.debug(message);
    return;
  }

  // Intentionally not console.warn/error - browsers attach a full call
  // stack to those, which drowns out the actual perf log when captured,
  // and the QA harness matches on this exact prefixed text.
  console.log(message);
  logPerfAdvice(label, suggestions);
}

/** Writes one `[PERF:ADVICE]` line per suggestion (same console.log rule). */
export function logPerfAdvice(
  label: string,
  suggestions: IPerfSuggestion[]
): void {
  suggestions.forEach((suggestion) =>
    console.log(
      `[PERF:${PerfChannel.ADVICE}] ${label} -> ${suggestion.message}`
    )
  );
}
